export class LoginError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = 'LoginError';
    }
}
//# sourceMappingURL=login_error.js.map